import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import App from './App.vue'
import router from '@/router/router'
import * as VueGoogleMaps from 'vue2-google-maps'
import store from '@/store'
import VueMarqueeSlider from 'vue-marquee-slider'
import VueCordova from 'vue-cordova'

Vue.use(VueMarqueeSlider)
Vue.use(VueCordova)

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyD1kSW4Y1zf2SBhqIHE4JhvLWODN9ZkvuI',
        libraries: 'places'
    }
})

Vue.config.productionTip = false
Vue.use(Vuetify)

Vue.prototype.$cordova = Vue.cordova
new Vue({
    cordova: Vue.cordova,
    router,
    store,
    vuetify: new Vuetify(),
    render: h => h(App)
}).$mount('#app')
